import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const ReorderTermsMutation = graphql.persisted(
  "ReorderTerms",
  graphql(`
    mutation ReorderTerms($input: ReorderTermsInput!) {
      reorderTerms(input: $input) {
        terms {
          id
          name
          slug
          position
          startsOn
          endsOn
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { ReorderTermsMutation };

export function useReorderTerms() {
  return useMutation(ReorderTermsMutation);
}
